import cabinetStyle from "./MentorCabinet.module.css";
import MentorPasswordChange from "./MentorPasswordChange";
import MentorPhoneNumber from "./MentorPhoneNumber";

export default function MentorSecuritySettings() {
    return <div className={cabinetStyle.mainPageContainer}>
            <MentorPasswordChange/>
            <MentorPhoneNumber/>
    </div>
}